import { render, staticRenderFns } from "./CKBasicEditor.vue?vue&type=template&id=15298190&"
import script from "./CKBasicEditor.vue?vue&type=script&lang=js&"
export * from "./CKBasicEditor.vue?vue&type=script&lang=js&"
import style0 from "./CKBasicEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports